import Button from '@atlaskit/button';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTE_PATHS } from 'settings';

const VpnReminderPage: FC = () => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(ROUTE_PATHS.FAQ.INDEX);
    window.location.reload();
  }, [navigate]);

  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '100vh', textAlign: 'center' }}>
      <div>
        <h3 style={{ paddingBottom: '32px' }}>
          Connection failed. Please check your internet connection or VPN settings
        </h3>

        <Button
          onClick={handleClick}
          appearance="primary"
        >{`I'm connected. Take me to the home page`}</Button>
      </div>
    </div>
  );
};

export default VpnReminderPage;
